import { PropsWithChildren } from 'react';

import { UserConfigurationContext } from '@/src/features/app/store/userConfiguration/context';
import { userConfigurationStore } from '@/src/features/app/store/userConfiguration/store';

export const UserConfigurationContextProvider = ({ children }: PropsWithChildren) => (
  <UserConfigurationContext.Provider value={userConfigurationStore}>{children}</UserConfigurationContext.Provider>
);
